// components/instagram.js
import { useEffect } from "react";

export const Instagram = () => {
  useEffect(() => {
    // Instagram埋め込み再処理
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, []);

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `
<blockquote
  class="instagram-media"
  data-instgrm-permalink="https://www.instagram.com/p/DUDUk9jkRRe/"
  data-instgrm-version="14"
  style="background:#FFF; border:0; max-width:540px; width:100%; margin:0 auto;"
></blockquote>
`
      }}
    />
  );
};